/**
 * Created by Zhonghua on 25/11/2016.
 */

export enum JsonTypeTagType {
  CLASS,
  TYPE,
  NONE,
}
